import {useParams} from "react-router-dom";
import {ViewDocumentPanel} from "document/component/container";
import {TanqueService} from "saneamiento/service";

const ViewTanqueDocumentPanel = () => {
    const {idTanque} = useParams();

    const handleSetFeaturedImage = documentId => {
        return TanqueService.updateWithPatch({
            id: idTanque,
            featured_image: documentId,
        });
    };

    const handleSetFeaturedDocument = documentId => {
        return TanqueService.updateWithPatch({
            id: idTanque,
            featured_document: documentId,
        });
    };

    return (
        <ViewDocumentPanel
            onSetFeaturedImage={handleSetFeaturedImage}
            onSetFeaturedDocument={handleSetFeaturedDocument}
        />
    );
};

export default ViewTanqueDocumentPanel;
